var map = {
	"./Bitterlove.png": 112,
	"./DeathBed.jpg": 113,
	"./Djperhatianmu.jpg": 114,
	"./Fallenkingdom.jpg": 115,
	"./Happy.jpg": 116,
	"./LemonTree.jpg": 117,
	"./Oneonly.jpg": 118,
	"./Pamungkas - Kenangan Manis.jpg": 119,
	"./Pastlive.jpg": 120,
	"./PlayDate.jpg": 121,
	"./alive.jpg": 122,
	"./apocalypse-1600776027-tsCmgK4gEU.jpg": 123,
	"./avatar2.jpg": 124,
	"./avatar3.jpg": 125,
	"./bot.jpg": 64,
	"./djopus.jpg": 126,
	"./fallinginlove.jpg": 127,
	"./headphones.svg": 128,
	"./headphonesLogo.svg": 35,
	"./hindia.jpg": 129,
	"./ignite-1600419626-nHn4WXY79q.jpg": 130,
	"./left.svg": 49,
	"./mc.png": 131,
	"./negaralucu.jpg": 132,
	"./notAvailable-removebg-preview.png": 133,
	"./notAvailable-removebg-preview.svg": 134,
	"./notAvailable.jpg": 135,
	"./profil.jpeg": 50,
	"./right.svg": 136,
	"./searchMusic.svg": 51,
	"./searchMusicDisc.svg": 52,
	"./searchMusicMp3.svg": 53,
	"./sesuatudijogja.jpg": 137,
	"./want-you-feat-sara-skinner-1586956276-s4lOrfrHQj.jpg": 138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;